import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'checkpoint-edit-summary',
    template: `
        <mat-card class="fi-rounded-card fi-checkpoint-edit-tab-description-card">
            <mat-card-content>
                <div>
                    <mat-card-title class="checklist-card-title">{{
                        'checklist.status_checkpoints' | fiAppText
                    }}</mat-card-title>
                    <p class="checkpoint-card-text">
                        {{ 'checklist.checkpoint_type_status_card_description' | fiAppText }}
                    </p>
                </div>

                <div>
                    <mat-card-title class="checklist-card-title">{{
                        'checklist.measurement_checkpoint' | fiAppText
                    }}</mat-card-title>
                    <p class="checkpoint-card-text">
                        {{ 'checklist.checkpoint_type_measurement_description_card' | fiAppText }}
                    </p>
                </div>

                <div>
                    <mat-card-title class="checklist-card-title">{{
                        'checklist.scoring_checkpoint' | fiAppText
                    }}</mat-card-title>
                    <p class="checkpoint-card-text">
                        {{ 'checklist.scoring_checkpoint_description_card' | fiAppText }}
                    </p>
                </div>
            </mat-card-content>
        </mat-card>
    `,
    styleUrls: ['./checkpoint-edit-summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'checkpoint-edit-summary' },
    standalone: false,
})
export class CheckpointEditSummaryComponent {}
